import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: ${({ device, data }) => (device !== 'desktop' && data ? '100%' : '327px')};
`;
const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ device }) => (device === 'mobile' ? '20' : '34')}px;
`;

const Icon = styled.div`
  width: 40px;
  height: 40px;
  background-image: ${({ icon }) => `url(${icon})`};
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 16px;
`;

const TitleText = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  height: 21px;
  margin-right: 9px;
`;

const TooltipComponent = styled.div`
  padding: 3px 8px;
  width: 270px;
  height: 64px;
  white-space: pre-wrap;
  text-align: center;
`;

const IconTooltip = styled.img`
  margin-top: 6px;
`;

export { Container, HeaderArea, Icon, TitleText, TooltipComponent, IconTooltip };
